// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ae-z","fullWidth":"Be-z","heading":"Ce-z","fullBleed":"De-z","hidden":"Ee-z"};